export type OrderingType =
    "String" |
    "Long" |
    "Double" |
    "AlphaNumeric";
